module.exports = __webpack_public_path__ + "files/83c19f271c449cd234194d492cafd779.png";